import useAuthTemplate from '@auth/components/template/hooks/useAuthTemplate'
import Grid from '@blocks/Grid'
import Button from '@components/blocks/Button'
import { route } from '@helpers'
import useTitle from '@hooks/useTitle'
import React from 'react'
import { useLocation } from 'react-router'

export default function WelcomePage() {
    const location = useLocation<"invited" | undefined>()

    useTitle("Welcome!")
    useAuthTemplate({
        social: true,
        description: location.state === "invited" 
            ? "You were invited to the group. Please, log in or register before accepting the invitation."
            : "Sign in or register using social media or email. You need to register only once to participate in all of our salons."
    })

    return (
        <Grid gap="15px">
            <Button to={route("signin")}>
                Sign in
            </Button>
            <Button to={route("signup")} type="secondary">
                Register
            </Button>
        </Grid>
    )
}